export default "__VITE_ASSET__XQx4GL47__"